import { atom } from 'jotai'
import { atomFamily } from 'jotai-family'

import type { HistoryFilterParams } from '@/service/ws/account-data-manager'

export const orderFilterAtom = atom<HistoryFilterParams>({
  symbols: [],
  currency: [],
  from: undefined,
  to: undefined,
})

export const EMPTY_TRADE_HISTORY_FILTER: HistoryFilterParams = {
  symbols: [],
  currency: [],
  from: undefined,
  to: undefined,
}

/**
 * The Positions widget's Trades-tab filter, per widget. Display-only: every widget reads the
 * one shared, unfiltered trade list (AccountTradesCoordinator) and narrows it here, so one
 * widget's filter never changes what another shows. Saved to the widget config
 * (`tradeHistoryFilter`, usePositionsConfigSync / restorePositions).
 */
export const tradeHistoryFilterAtomFamily = atomFamily((_cardId: string) =>
  atom<HistoryFilterParams>(EMPTY_TRADE_HISTORY_FILTER)
)

export function hasTradeHistoryFilter(filter: HistoryFilterParams): boolean {
  return Boolean(filter.symbols?.length || filter.currency?.length || filter.from || filter.to)
}
